var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQ(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 90 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 45,
    style: {
      fill: "#fccc0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.597 61.406c.586-.152 1.335-.423 2.246-.814l-4.85-4.622 5.176-5.404 4.85 4.623c.76-1.563 1.291-2.93 1.595-4.102.477-1.758.716-3.808.716-6.152 0-5.382-1.101-9.543-3.304-12.484-2.203-2.94-5.42-4.41-9.652-4.41-3.971 0-7.14 1.41-9.505 4.231-2.365 2.821-3.548 7.042-3.548 12.663 0 6.575 1.693 11.285 5.078 14.127 2.192 1.845 4.818 2.767 7.878 2.767 1.15 0 2.257-.14 3.32-.423Zm18.197-6.445c-.847 2.756-2.095 5.046-3.744 6.868l5.534 5.176-5.24 5.469-5.795-5.469c-1.758 1.064-3.277 1.812-4.557 2.246-2.149.716-4.72 1.075-7.715 1.075-6.25 0-11.415-1.867-15.495-5.6-4.948-4.492-7.422-11.089-7.422-19.791 0-8.768 2.54-15.397 7.617-19.89 4.145-3.667 9.3-5.5 15.463-5.5 6.206 0 11.414 1.941 15.625 5.826 4.86 4.492 7.291 10.775 7.291 18.848 0 4.275-.52 7.856-1.562 10.742Z",
    style: {
      fill: "#000",
      fillRule: "nonzero"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQ);
export default __webpack_public_path__ + "static/media/q.6f1697f2319529fc34307d24c9b95178.svg";
export { ForwardRef as ReactComponent };